import { FC } from "react";
import { Flex } from 'rebass/styled-components'
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend } from "recharts";

interface IProps {
  chartData: Array<{
    question: string,
    [key: string]: any
  }> | null,
  filledSurveys: Array<string>,
  hideLegend?: boolean
}

function customTick({ payload, x, y, textAnchor, stroke, radius }: any) {
  return (
    <g
      className="recharts-layer recharts-polar-angle-axis-tick"
    >
      <text
        radius={radius}
        stroke={stroke}
        x={x}
        y={y}
        className="recharts-text recharts-polar-angle-axis-tick-value"
        text-anchor={textAnchor}
      >
        <tspan x={x} dy="0em" fill="#4E658A" opacity={0.75} fontSize='12px'>
          {payload.value}
        </tspan>
      </text>
    </g>
  );
}
const getColors = (name: string) => {
  switch (name) {
    case 'BASELINE':
      return "rgb(246, 162, 147)"
    case "FOLLOWUP1":
      return "#4E658A"
    case "FOLLOWUP2":
      return "rgb(184, 214, 245)"
    case "FOLLOWUP3":
      return "rgb(253, 245, 242)"
      case "FOLLOWUP4":
        return "rgb(174, 149, 139)"

    default:
      break;
  }
}
export const SurveyChart: FC<IProps> = ({ chartData, hideLegend, filledSurveys }) => {
  console.log({ filledSurveys, chartData })
  if (!chartData) return null;

  return (
    <Flex flexDirection={'column'} width='100%'>
      <Flex height={'65vh'} maxHeight='900px'>
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart cx="50%" cy="50%" outerRadius="80%" data={chartData}>
            <PolarGrid />
            <PolarAngleAxis dataKey="question" tick={customTick} />
            <PolarRadiusAxis angle={30} domain={[0, 4]} />
            {filledSurveys.map((x, i) => {
              return (
                <Radar key={`rdr${x}`} name={x} dataKey={x} stroke={getColors(x)} fill={getColors(x)} fillOpacity={0.4} />)
              // <Radar name="Follow up 1" dataKey="keyFu" stroke="#4E658A" fill="#4E658A" fillOpacity={0.6} />
            })}
            {!hideLegend && <Legend dy="6em" />}
          </RadarChart>
        </ResponsiveContainer>
      </Flex>
    </Flex>
  );
}